export default __webpack_public_path__ + "static/media/mail-opened-colored.9cd48aed.svg";